import { OptionType, SeeClientsEnum } from '@uplift/types';

export const EMPTY_STRING = '';
export const EMPTY_FUNCTION = () => {
  //DO NOTHING
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTHS_OPTIONS: OptionType[] = MONTHS.map((month) => ({
  label: month,
  value: month,
}));

export const DEGREE_OPTOINS = [
  {
    label: 'Associate’s',
    value: "Associate's",
  },
  {
    label: 'Bachelor’s',
    value: "Bachelor's",
  },
  {
    label: 'Master’s',
    value: "Master's",
  },
  {
    label: 'Doctorate',
    value: 'Doctorate',
  },
];

export enum TimeFormats {
  LT = 'LT',
  'h:mm' = 'h:mm',
  'h:mm A' = 'h:mm A',
  'h:mm a' = 'h:mm a',
  'h:mma' = 'h:mma',
  'm' = 'm',
  minutes = 'minutes',
  'h' = 'h',
  'ha' = 'ha'
}

export enum DateFormats {
  'ISO' = 'yyyy-MM-DDTHH:mm:ssZ',
  'ISODayjs' = 'YYYY-MM-DDTHH:mm:ssZ',
  'yyyy-MM-DD' = 'yyyy/MM/DD',
  YYYY_MM = 'YYYY-MM',
  'DD-MM-YYYY' = 'DD/MM/YYYY',
  'MM/YYYY' = 'MM/YYYY',
  'M/D/YY' = 'M/D/YY',
  'ddd M/D/YY' = 'ddd M/D/YY',
  'ddd, D MMMM YYYY' = 'ddd, D MMMM YYYY',
  'dddd, MMMM D, YYYY' = 'dddd, MMMM D, YYYY',
  'dddd MMMM D, YYYY' = 'dddd MMMM D, YYYY',
  'dddd, MMM. D' = 'dddd, MMM. D',
  shortWeekdayShortMonthDate = 'ddd, MMM D',
  fullWeekdayFullMonthDate = 'dddd, MMMM D',
  weekDay = 'dddd',
  month = 'MMMM',
  shortMonth = 'MMM',
  days = 'days',
  'DD' = 'DD',
  'D' = 'D',
  'MMM D, YYYY' = 'MMM D, YYYY',
  'MMMM D, YYYY' = 'MMMM D, YYYY',
  'MMM, ddd, DD' = 'MMM, ddd, DD',
  'MM/YY' = 'MM/YY',
  'MM/DD' = 'MM/DD',
  'MM/DD/YY' = 'MM/DD/YY',
  'M/D/YYYY' = 'M/D/YYYY',
  'hh:mm A' = 'hh:mm A',
  'hh:mm a' = 'hh:mm a',
  DEFAULT_DATE = 'MM/DD/YYYY',
  ISO_DATE = 'YYYY-MM-DD',
  FULL_DAY_SHORT_TIME = 'dddd h:mm A',
  DATETIME = 'M/D/YY, hh:mm a',
}

export const waysToSeeClients = {
  mix: 'Both',
  telehealth: 'Video',
  inPerson: 'In-person',
};

export const SEE_CLIENTS_OPTIONS = [
  {
    label:
      waysToSeeClients.mix,
    value: SeeClientsEnum.videoAndInPerson,
  },
  {
    label:
      waysToSeeClients
        .telehealth,
    value: SeeClientsEnum.telehealth,
  },
  {
    label:
      waysToSeeClients
        .inPerson,
    value: SeeClientsEnum.inPerson,
  },
];

export const DEFAULT_DEGREE = {
  school: EMPTY_STRING,
  year_graduated: EMPTY_STRING,
  field_of_study: EMPTY_STRING,
  degree: EMPTY_STRING,
};

export const NULL_UUID = '00000000-0000-0000-0000-000000000000';
export const SYSTEM_USER_NAME = 'Uplift Bot';
